export type SetterFunction<T> = (value: T) => void;
export type ValidatorFunction = (value: any) => string | true;

export enum InputType {
  TYPE_TEXT = 'text',
  TYPE_NUMBER = 'number',
  TYPE_FLOAT = 'float',
  TYPE_DOUBLE = 'double',
  TYPE_INTEGER = 'integer',
  TYPE_DATE = 'date',
  TYPE_DATE_RANGE = 'date-range',
  TYPE_TIME_RANGE = 'time-range',
  TYPE_CHECKBOX = 'checkbox',
  TYPE_CHECKBOX_GROUP = 'checkbox-group',
  TYPE_RADIO_GROUP = 'radio-group',
  TYPE_SELECT = 'select',
  TYPE_TEXTAREA = 'textarea',
  TYPE_PASSWORD = 'password',
  TYPE_AUTOCOMPLETE = 'autocomplete',
  TYPE_FREE_TAGS = 'free-tags',
  TYPE_FILE_DRAG_DROP = 'file-drag-drop',
}

export const mapTypeToInputType = (type: InputType) => {
  switch (type) {
    case InputType.TYPE_TEXT:
      return 'text';
    case InputType.TYPE_TEXTAREA:
      return 'textarea';
    case InputType.TYPE_NUMBER:
    case InputType.TYPE_FLOAT:
    case InputType.TYPE_DOUBLE:
    case InputType.TYPE_INTEGER:
      return 'number';
    case InputType.TYPE_DATE:
      return 'date';
    case InputType.TYPE_CHECKBOX:
      return 'checkbox';
    case InputType.TYPE_CHECKBOX_GROUP:
      return 'checkbox-group';
    case InputType.TYPE_PASSWORD:
      return 'password';
    default:
      return type;
  }
};

export const parseByType = (type: InputType, rawValue: string) => {
  switch (type) {
    case InputType.TYPE_NUMBER:
    case InputType.TYPE_FLOAT:
    case InputType.TYPE_DOUBLE:
      if (rawValue === '-' || rawValue === '') {
        return rawValue;
      }
      if (isNaN(parseFloat(rawValue))) {
        return 0;
      }
      return parseFloat(rawValue);
    case InputType.TYPE_INTEGER:
      if (rawValue === '-' || rawValue === '') {
        return rawValue;
      }
      return parseInt(rawValue, 10);
    case InputType.TYPE_DATE:
    case InputType.TYPE_TEXT:
    case InputType.TYPE_CHECKBOX:
    case InputType.TYPE_CHECKBOX_GROUP:
    case InputType.TYPE_SELECT:
    case InputType.TYPE_TEXTAREA:
    case InputType.TYPE_PASSWORD:
    case InputType.TYPE_RADIO_GROUP:
    default:
      return rawValue;
  }
};
